import * as React from 'react';

import { useAssessmentContext } from '../../context';
import IAssessmentElement from '../../models/IAssessmentElement';
import { IValidatorConfig, IValidatorResult } from '../../models/IValidator';
import useQuestionManager from '../../plugins/useQuestionManager';
import DateField from '../inputs/DateField';

interface IProps 
{
	question: IAssessmentElement,
	onValidatorResultChanged?(validatorResult: IValidatorResult): void,
	onResetValidation?(parentElement: IAssessmentElement | null): void,
	validatorConfig?: IValidatorConfig
}

export function DateInput(props: IProps)
{
	const assessmentContext = useAssessmentContext();
	const questionManager = useQuestionManager();
	const [answerValues, setAnswerValues] = React.useState<string[]>(assessmentContext.pageAnswers.filter(x => x.id == props.question.id)[0]?.value ?? []);

	// Sync with external updates from Redux (e.g., address lookup population)
	React.useEffect(() =>
	{
		const externalAnswers = assessmentContext.pageAnswers.filter(
			x => x.id == props.question.id
		)[0]?.value ?? [];

		setAnswerValues(externalAnswers);
	}, [assessmentContext.pageAnswers, props.question.id]);

	const onDateChange = (date: string) =>
	{
		setAnswerValues([date])
		questionManager.updateAnswerValue(props.question.id, [date]);

		if(props.onResetValidation && props.question.hasConditionalChildren)
			props.onResetValidation(props.question);
	};

	return <DateField
		onValidatorResultChanged={props.onValidatorResultChanged}
		validator={{
			validatorRules: questionManager.getQuestionValidatorRules(props.question),
			config: props.validatorConfig
		}}
		value={(answerValues.length) ? answerValues[0] : ''}
		answerValue={answerValues}
		onDateChange={onDateChange}/>
}

export default DateInput;
